import { useSelector } from 'react-redux'
import { useTranslation } from 'next-i18next'

import React from 'react'
import styled from '@emotion/styled'
import { RootState } from '../../../../redux/store'
import { UiIcon, UiIcon2 } from '../../../ui/atoms/Icon'
import { capitalizePhrase } from '../../../../utils/capitalize'
import { Tooltip } from '../../../ui/atoms/Tooltip'
import { createLightTint } from '../../../../utils/selectContrastingColor'
import useConfig from '../../../config/state/use-config'
import { SINGLE_STEP_NAME } from '../../../flow/state/utils/steps/single-step.utils'
import { STEP_LAYOUT_SMALL_WIDTH } from 'modules/flow/components/shared/shared-step-layout.styled'

const Header = styled.div<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: var(--theme-color__text-general);
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 20px 20px 0 0;

  strong {
    white-space: nowrap;
  }

  @media (max-width: ${STEP_LAYOUT_SMALL_WIDTH}) {
    border-radius: 0;
  }
`

export default function DedicationPreConversionPreview() {
  const urlParams = useSelector((state: RootState) => state.urlParams)
  const flow = useSelector((state: RootState) => state.flow)
  const dedication = urlParams.dedication
  const { t } = useTranslation()
  const config = useConfig()

  // Only show on the single step (first step in non-embedded flow)
  const isFirstStep = flow.currentStepName === SINGLE_STEP_NAME

  // Get campaign theme colors
  const primaryColor = config.theme['--theme-color__brand-primary']

  // Create a very light tint of the primary color for background
  const bgColor = createLightTint(primaryColor)

  return (
    <>
      {dedication && isFirstStep && (
        <Header backgroundColor={bgColor}>
          <UiIcon2 aria-hidden="true" name="donation" color={primaryColor} w={20} h={20} />
          {t('dedicationPreConversionPreview.dedicatedTo', 'Dedicated to')}{' '}
          <strong>{capitalizePhrase(dedication)}</strong>
          <Tooltip
            text={t(
              'dedicationPreConversionPreview.tooltip.completeNoteMessage',
              "You'll be able to add a note and complete your dedication later.",
            )}
            placement="top"
          >
            <UiIcon name="info" color={primaryColor} w={18} style={{ marginTop: '2px' }} />
          </Tooltip>
        </Header>
      )}
    </>
  )
}
